import { Center, Spinner } from '@chakra-ui/react';
import useAccountIdQueryParam from 'hooks/modules/brokerAccount/useAccountIdQueryParam';
import useUpdateCompaniesPieColors from 'hooks/modules/companiesPieColors/useUpdateCompaniesPieColors';
import usePeriodQueryParam from 'hooks/modules/period/usePeriodQueryParam';
import useAppSelector from 'hooks/shared/store/useAppSelector';
import AnalyticsCompaniesLoaded from 'presentation/components/modules/analytics/companies/AnalyticsCompaniesLoaded';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchPortfolioQuery } from 'rtkQuery/sharespro/queries/portfolio';
import { companiesPieColorsSelector } from 'selectors/modules/companies/companiesPieColors';

const PortfolioAnalyticsContainer: FC = () => {
  const pieColors = useAppSelector(companiesPieColorsSelector);

  const [accountId] = useAccountIdQueryParam();
  const [period] = usePeriodQueryParam();
  const { currentData, error, refetch, isFetching } = useFetchPortfolioQuery({
    period,
    account_id: accountId,
  });

  useUpdateCompaniesPieColors(
    currentData?.analytics.map((company) => company.name) ?? []
  );

  const { t } = useTranslation();

  let content;
  if (isFetching) {
    content = (
      <Center py={10}>
        <Spinner />
      </Center>
    );
  } else if (currentData) {
    content = (
      <AnalyticsCompaniesLoaded
        companies={currentData.analytics}
        pieColors={pieColors}
      />
    );
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  return (
    <>
      <GridHeading>{t('analytics')}</GridHeading>
      <AppCard
        p="20px"
        minH="250px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {content}
      </AppCard>
    </>
  );
};

export default PortfolioAnalyticsContainer;
